import { Languages } from "src/common/descriptions/types";
import { CompanyDataDescriptions } from "./types";

const DescriptionsEnUs: CompanyDataDescriptions = {
    TITLE: "Update Company Data",
    SAVE_BUTTON: "Save",
    CANCEL_BUTTON: "Cancel",
    CONFIRM_MODAL: {
        TITLE: 'Save Company Data?',
        DESCRIPTION: "You can always change this values.",
        ACTION_BUTTON: "Save",
        CANCEL_BUTTON: "Go Back",
    },
    CANCEL_MODAL: {
        TITLE: "Cancel Company Data input?",
        DESCRIPTION: "All data will be lost.",
        ACTION_BUTTON: "Yes, Cancel",
        CANCEL_BUTTON: "Keep working",
    },
    SUCCESS_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Company Data Created",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Company Data Updated",
    },
    FORM: {
        NAME: {
            LABEL: "Name",
            PLACEHOLDER: "Input Company Name",
        },
        ADDRESS: {
            LABEL: "Address",
            PLACEHOLDER: "Input Address",
        },
        PHONE: {
            LABEL: "Phone",
            PLACEHOLDER: "Input Phone",
        },
        CITY: {
            LABEL: "City",
            PLACEHOLDER: "Input City",
        },
        STATE: {
            LABEL: "State",
            PLACEHOLDER: "Input State",
        },
        EMAIL: {
            LABEL: "Email",
            PLACEHOLDER: "Input email",
        },
        SLOGAN: {
            LABEL: "Slogan",
            PLACEHOLDER: "Input slogan",
        },
        LOGO_URL: {
            LABEL: "Logo",
            PLACEHOLDER: "Upload",
        },
    },
    MAIN_ACTION_TITLE: "Updateing Company Data",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
}

const DescriptionsEsUs: CompanyDataDescriptions = {
    TITLE: "Actualizar Datos de Empresa",
    SAVE_BUTTON: "Guardar",
    CANCEL_BUTTON: "Cancelar",
    CONFIRM_MODAL: {
        TITLE: 'Guardar Empresa con los datos ingresados?',
        DESCRIPTION: "Puedes editar esta información cuando gustes.",
        ACTION_BUTTON: "Guardar",
        CANCEL_BUTTON: "Regresar",
    },
    CANCEL_MODAL: {
        TITLE: "Cancelar ingreso de Empresa?",
        DESCRIPTION: "La información ingresada sera borrada.",
        ACTION_BUTTON: "Si, Cancelar",
        CANCEL_BUTTON: "Seguir ingresando",
    },
    SUCCESS_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Empresa creada",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Datos de empresa actualizados",
    },
    FORM: {
        NAME: {
            LABEL: "Nombre",
            PLACEHOLDER: "Ingresa el nombre",
        },
        ADDRESS: {
            LABEL: "Dirección",
            PLACEHOLDER: "Ingresa dirección",
        },
        PHONE: {
            LABEL: "Teléfono",
            PLACEHOLDER: "Ingresa teléfono",
        },
        CITY: {
            LABEL: "Ciudad",
            PLACEHOLDER: "Ingresa ciudad",
        },
        STATE: {
            LABEL: "Departamento",
            PLACEHOLDER: "Ingresa departamento",
        },
        EMAIL: {
            LABEL: "Correo",
            PLACEHOLDER: "Ingresa correo",
        },
        SLOGAN: {
            LABEL: "Slogan",
            PLACEHOLDER: "Ingresa slogan",
        },
        LOGO_URL: {
            LABEL: "Logo",
            PLACEHOLDER: "Seleccionar",
        },
    },
    MAIN_ACTION_TITLE: "Actualizando datos de Empresa",
    MAIN_ACTION_DESCRIPTION: "Por favor espere...",
}

export const companyDataDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}